import Styles from './SectionHeader.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { FormStatus } from './Types'
import { useFormikContext } from 'formik'
import { Button } from 'blaze-ui/Button'
import { ResetFormButton } from './ResetFormButton'
import { useSections } from 'components/Wizards/Wizard/Form/Sections/SectionsProvider'
import { useEffect, useState } from 'react'

export const LoadingEllipses = () => {
  const [visibleCount, setVisibleCount] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setVisibleCount((prevCount) => (prevCount + 1) % 4)
    }, 500)

    return () => clearInterval(interval)
  }, [])

  return (
    <>
      <span style={{ visibility: visibleCount > 0 ? 'visible' : 'hidden' }}>.</span>
      <span style={{ visibility: visibleCount > 1 ? 'visible' : 'hidden' }}>.</span>
      <span style={{ visibility: visibleCount > 2 ? 'visible' : 'hidden' }}>.</span>
    </>
  )
}

const AutoFillingHeader = () => (
  <div className={Styles.header}>
    <Text>
      Blaze is filling out the information below
      <LoadingEllipses />
    </Text>
  </div>
)

const Header = () => {
  const { createFieldsetCompletion } = useSections()
  return (
    <div className={Styles.header}>
      <Text>Would you like Blaze to autocomplete the rest of this wizard?</Text>
      <Button onPress={createFieldsetCompletion} size="md">
        Fill the rest in for me
      </Button>
    </div>
  )
}

const AutoFilledHeader = () => (
  <div className={Styles.header}>
    <Text>The fields below have been filled in by Blaze</Text>
    <ResetFormButton />
  </div>
)

export const SectionHeader = () => {
  const { status } = useFormikContext()

  if (status === FormStatus.AutoFilling) {
    return <AutoFillingHeader />
  }

  if (status === FormStatus.AutoFilled) {
    return <AutoFilledHeader />
  }

  return <Header />
}
